import { render, staticRenderFns } from "./AddLiquidity.vue?vue&type=template&id=51b98918&"
import script from "./AddLiquidity.vue?vue&type=script&lang=js&"
export * from "./AddLiquidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports